import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['main', 'item', 'checkbox']

  toggle () {
    const checked = this.mainTarget.checked
    this.selectableItemTargets.forEach(checkbox => {
      checkbox.checked = checked
    })
  }

  sync () {
    const selectableItems = this.selectableItemTargets
    if (selectableItems.length === 0) return

    const allChecked = selectableItems.every(cb => cb.checked)
    const someChecked = selectableItems.some(cb => cb.checked)

    this.mainTarget.checked = allChecked
    this.mainTarget.indeterminate = !allChecked && someChecked
  }

  mirror (event) {
    const { name, value, checked } = event.target
    this.checkboxTargets
      .filter(cb => cb.name === name && cb.value === value && cb !== event.target)
      .forEach(cb => { cb.checked = checked })
  }

  get selectableItemTargets () {
    return this.itemTargets.filter(checkbox => !checkbox.disabled)
  }
}
